import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-itm',
  templateUrl: './itm.component.html',
  styleUrls: ['./itm.component.scss']
})
export class ItmComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
